import { microserviceApi, microServiceApiWithTokenRevoke } from "./microserviceApi";

export const dash = microserviceApi.injectEndpoints({
  endpoints: (builder) => ({
    getCertificate: builder.query({
      query: (data) => ({
        url: `/MySelf/getCertificate`,
        method: "GET",
        headers: {
          reference: data?.reference,
          document: data?.document,
          status: data?.status,
          startDate: data?.startDate,
          endDate: data?.endDate,
          lastStatusStartDate: data?.lastStatusStartDate,
          lastStatusEndDate: data?.lastStatusEndDate,
          applicationId: data?.applicationId,
        },
      }),
      providesTags: ['Certificate'],
      extraOptions: { maxRetries: 0 },
      keepUnusedDataFor: 0,
    }),
    getHistoric: builder.query({
      query: (data) => ({
        url: `/MySelf/getstatushistory`,
        method: "GET",
        headers: {
          contractRequestId: data.crId,
        },
      }),
      extraOptions: { maxRetries: 0 },
      keepUnusedDataFor: 0,
    }),
    getRequestInformation: builder.query({
      query: (data) => ({
        url: `/MySelf/getRequestInformation`,
        method: "GET",
        headers: {
          contractRequestId: data.crId,
        },
      }),
      transformResponse: (response) => {
        return {
          status: true,
          statusDescription: "Consulta realizada correctamente.",
          data: {
            subject: Object.keys(response.data.subject).map((key) => ({
              key: key.toUpperCase(),
              value: response.data.subject[key],
            })),
            detail: response.data.detail,
            det: response.data.detail,
          },
        };
      },
      extraOptions: { maxRetries: 0 },
    }),
    reviewCertificate: builder.mutation({
      query: (data) => ({
        url: `/MySelf/reviewCertificate`,
        method: "POST",
        body: data,
      }),
      extraOptions: { maxRetries: 0 },
    }),
    issuanceCertificate: builder.mutation({
      query: (data) => ({
        url: `/MySelf/issueCertificate`,
        method: "POST",
        body: data,
      }),
      transformResponse: (response) => {
        if (response && response.data && response.data.error &&( response.data.error.includes("CertificateCreateException") ||
          response.data.error.includes("CryptoTokenOfflineException") ||
          response.data.error.includes("Error invocando") ||
          response.data.error.includes("The server didn't respond in time.") ||
          response.data.error.includes("One or more errors occurred. (A task was canceled.)"))
        ) {
          return { status: response.status,statusDescription: 'Fallo en la PKi' }
        } else if (response && response.data && response.data.error && response.data.error === "One or more errors occurred. (The SSL connection could not be established, see inner exception.)") {
          return { status: response.status,statusDescription: 'Fallo en la generación del documento' }
        } else if (response && response.status == true){
          return { status: response.status , statusDescription: response.statusDescription }
        } else if (response && response.data && response.data.error && response.data.error.includes("Object reference") ) {
          return { status: response.status , statusDescription: 'Error en la emisión del certificado' }
        } else if (response && response.data && response.data.message && response.data.message.includes("Subject") ) {
          return { status: response.status , statusDescription: 'Problemas con el subject, no se ha podido realizar la emisión' }
        } else if (response?.statusDescription.includes("por favor intenta en unos minutos")){
          return { status: response.status , statusDescription: response.statusDescription }
        } else if (response?.statusDescription.includes("El oficial no")){
          return { status: response.status , statusDescription: response.statusDescription }
        } else {
          const errorData = response?.data?.error ? response.data.error : 'Fallo ejecutando solicitud';
          return { status: response.status , statusDescription: errorData }
        }
        //return response?.data
      },
      transformErrorResponse: (response) => response?.data,
      extraOptions: { maxRetries: 0 },
    }),
    getConstancy: builder.mutation({
      query: (data) => ({
          url: `/Consult/getConstancy`,
          method: "GET",
          headers: {
              "contractRequestId": data.externalRequestId
          },
      }),
      extraOptions: { maxRetries: 0 },
  }),
  }),
});
export const dashWithTokenRevoke = microServiceApiWithTokenRevoke.injectEndpoints({
  endpoints: (builder) => ({
    getCertificateToRevoke : builder.query({
      query: (data) => ({
        url: `/MySelf/getCertificateToRevoke`,
        method: "GET",
        headers: {
          documentType: data?.documentType,
          documentNumber : data?.documentNumber,
          email: data?.email,
        },
      }),
      extraOptions: { maxRetries: 0 },
      keepUnusedDataFor: 0,
    }),
  }),
});
export const {
  useLazyGetCertificateToRevokeQuery
} = dashWithTokenRevoke;

export const {
  useGetCertificateQuery,
  useGetRequestInformationQuery,
  useGetHistoricQuery,

  useReviewCertificateMutation,
  useIssuanceCertificateMutation,
  useGetConstancyMutation,
} = dash;

export const reset = dash.util.invalidateTags(["Certificate"])
